import apiClient from "src/utils/apiClient";
import type {
  UseCaseConfig,
  WorkspaceTask,
  WorkspaceResult,
} from "src/components/pages/auditModule/shared/types";

//TODO: Replace placeholder endpoints with real backend routes once Audit V2 APIs are implemented.
export interface AuditModuleTasksResponse {
  tasks: Array<{
    id: string;
    use_case_id: string;
    status: string;
    assigned_to: string | null;
    priority: number;
    created_at: string;
  }>;
}

export interface AuditModuleUseCasesResponse {
  use_cases: Array<{
    id: string;
    name: string;
    inter_rater_count: number;
  }>;
}

export interface AuditModuleResultsResponse {
  results: Array<{
    id: string;
    task_id: string;
    auditor_id: string;
    status: string;
    decisions: Record<string, { decision: string }>;
  }>;
}

export interface AuditModuleUseCaseConfigsResponse {
  configs: UseCaseConfig[];
}

export interface AuditModuleSingleConfigResponse {
  config: UseCaseConfig;
}

export interface AuditModuleWorkspaceTaskResponse {
  task: WorkspaceTask | null;
  config: UseCaseConfig | null;
  result: WorkspaceResult | null;
  allTasks: WorkspaceTask[];
}

export interface AuditModuleWorkspaceResultResponse extends WorkspaceResult {}

class AuditModuleService {
  async getTasks(): Promise<AuditModuleTasksResponse> {
    const { data } = await apiClient.get("/audit_queue/tasks");
    return data;
  }

  async getUseCases(): Promise<AuditModuleUseCasesResponse> {
    const { data } = await apiClient.get("/audit_queue/use_cases");
    return data;
  }

  async getResults(taskIds: string[]): Promise<AuditModuleResultsResponse> {
    const { data } = await apiClient.post("/audit_queue/results", { task_ids: taskIds });
    return data;
  }

  // ----------------------------  Config Endpoints  ----------------------------

  async getUseCaseConfigs(): Promise<AuditModuleUseCaseConfigsResponse> {
    const { data } = await apiClient.get("/audit_config/use_cases");
    return data;
  }

  async createUseCaseConfig(config: UseCaseConfig): Promise<AuditModuleSingleConfigResponse> {
    const { data } = await apiClient.post("/audit_config/use_cases", config);
    return data;
  }

  async updateUseCaseConfig(config: UseCaseConfig): Promise<AuditModuleSingleConfigResponse> {
    const { data } = await apiClient.put("/audit_config/use_cases/" + config.id, config);
    return data;
  }

  // ----------------------------  Workspace Endpoints  ----------------------------

  async getWorkspaceTask(taskId: string): Promise<AuditModuleWorkspaceTaskResponse> {
    const { data } = await apiClient.get("/audit_workspace/tasks/" + taskId);
    return data;
  }

  async saveWorkspaceResult(
    result: WorkspaceResult,
    submit: boolean,
  ): Promise<AuditModuleWorkspaceResultResponse> {
    const { data } = await apiClient.post("/audit_workspace/results", { ...result, submit });
    return data;
  }
}

export default new AuditModuleService();
